"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulkActionType = void 0;
var BulkActionType;
(function (BulkActionType) {
    BulkActionType["MoveCaseStatus"] = "MOVE_CASE_STATUS";
    BulkActionType["PauseCases"] = "PAUSE_CASES";
    BulkActionType["ContinueCases"] = "CONTINUE_CASES";
    BulkActionType["RunProcedure"] = "RUN_PROCEDURE";
    BulkActionType["ChangeBillingModel"] = "CHANGE_BILLING_MODEL";
    BulkActionType["ChangeBillingAppendixSetup"] = "CHANGE_BILLING_APPENDIX_SETUP";
    BulkActionType["ChangeWorkflow"] = "CHANGE_WORKFLOW";
    BulkActionType["MoveCaseToWorkflowTask"] = "MOVE_WORKFLOW_TASK";
    BulkActionType["RollbackOneTask"] = "ROLLBACK_ONE_TASK";
    BulkActionType["RollbackAllTasks"] = "ROLLBACK_ALL_TASKS";
    BulkActionType["RunBillingModel"] = "RUN_BILLING_MODEL";
    BulkActionType["ResubscribeCosmo"] = "RESUBSCRIBE_COSMO";
    BulkActionType["ChangeCaseGroup"] = "CHANGE_CASE_GROUP";
    BulkActionType["ResyncCosmo"] = "RESYNC_COSMO";
})(BulkActionType || (exports.BulkActionType = BulkActionType = {}));
//# sourceMappingURL=bulk-actions.js.map